<template>
  <div
    :class="{
      'nvr-box': true,
      'nvr-box-large': scale < 1.6 ? true : false,
      'nvr-box-tiny': scale >= 1.6 ? true : false,
    }"
  >
    <!-- <div class="close-box" @click="close"></div> -->
    <!--<div class="nvr-back-box" v-if="dialog.channeliItem.comeMore"  v-dialog="{name:'more-video-dialog',drag:true,top:'0',left:'0',opacity:1}"></div>-->
    <div class="nvr-player">
      <div class="player_title"></div>
      <div id="divPlugin" class="plugin">
        <video
          v-if="isVideo"
          id="myPlayer"
          class="centeredVideo"
          controls
          muted
          autoplay
          width="1024"
          height="400"
        >
          Your browser is too old which doesn't support HTML5 video.
        </video>
        <video
          v-else-if="!isVideo"
          id="recoderVideo"
          class="centeredVideo"
          x5-video-player-typ="h5"
          x-webkit-airplay="true"
          x5-video-player-fullscreen="true"
          preload="auto"
          playsinline="true"
          webkit-playsinline
          muted
          width="1024"
          height="400"
        ></video>
      </div>
      <div v-if="!isVideo" class="recoder-bar">
        <div
          class="recoders"
          v-for="(item, n) in recoderList"
          v-bind:key="'recoder-' + n"
          :style="{ left: item.l + 'px', width: item.w + 'px' }"
        ></div>
        <div ref="sliderBar" class="block">
          <el-slider
            @change="recordChange()"
            v-model="curRecodeTime"
            :format-tooltip="formatTooltip"
          ></el-slider>
        </div>
      </div>
      <div v-if="!isVideo" class="hour-bar">
        <div class="hour-item" v-for="(item, n) in hourList" v-bind:key="'hour-' + n">
          {{ item }}
        </div>
      </div>
      <div class="player_right">
        <div v-if="!isLive" class="player_left_inner">
          <div class="speed_box">
            <ul>
              <li
                :class="{ greenStyle: styleType === 'typeGreen' ? true : false }"
                @click="clickPlaySlow()"
              >
                慢放
              </li>
              <li
                :class="{ greenStyle: styleType === 'typeGreen' ? true : false }"
                @click="clickPlayFast()"
              >
                快放
              </li>
            </ul>
          </div>
        </div>
        <div class="player_SE" v-if="!isLive">
          <div class="chooseTime player_S">
            <label for="" @click="label_click($event)">选择时间：</label>
            <div class="chooseTimeBg starttime_box">
              <el-date-picker
                v-model="recodeDate"
                @change="date_change"
                type="datetime"
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="pickerOptionsStart"
                popper-class="video_date_class_cvr"
                :popper-append-to-body="false"
                placeholder="开始时间"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <div class="player_live_back">
          <i class="icon_live_back"></i>
          <span v-if="isLive" @click="goReview()">查看回放</span>
          <span v-else @click="goLive()">返回直播</span>
        </div>
        <div class="player_speed">
          <!--<label>倍速</label>-->
        </div>
      </div>
      <!--<div id="divPlugin" style="width: 430px;height: 380px;"  class="plugin"></div>-->
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import flvjs from "flv-h265.js";
import axios from "axios";
import { unref } from "vue";
export default {
  props: ["name", "icon", "actived", "inner"],
  name: "nvr-player",
  props: ["videoInfo", "videoClose"],
  inject: ["getVideoClose", "updateVideoType"],
  data() {
    return {
      customerId: this.$store.state.customerId,
      VIEW_WIDTH: bmeConfig.scaleRate,
      videoBaseUrl: bmeConfig.easyNvrUrl, //工厂本地地址
      easyNvrProtocol: bmeConfig.easyNvrProtocol,
      flvOrRtmp: "FLV",
      videoUrl: "",
      isVideo: true, //强制刷新使用
      player: null,
      recoderVideo: null,
      hls: null,
      iChannelId: 1,
      scale: 1,
      nvrChannel: 0,
      keepAliveTimer: "",
      recoderList: [],
      recodeDate: "",
      pickerOptionsStart: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
      },
      isLive: true,
      curChannel: "",
      recoderURL: "",
      recordeId: "",
      deviceId: "",
      flvUrl: "",
      recorderUrl: "",
      hourList: [
        "00:00",
        "01:00",
        "02:00",
        "03:00",
        "04:00",
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00",
      ],
      curRecodeTime: 0,
      flvTimer: null,
      flvPlayer: null,
      curVideoClose: "",
      keepRecoderAliveTimer: null,
      recorderTimer: null,
    };
  },
  watch: {
    /*"dialog.channelId"(channelId) {
      this.getChannelStream(channelId);
    },*/
    isVideo: {
      handler(newVal, oldVal) {
        if (!newVal) {
          let that = this;
          this.videoBaseUrl = bmeConfig.easyNvrUrl;
          this.easyNvrProtocol = bmeConfig.easyNvrProtocol;
          this.flv_destroy();
          this.$nextTick(function () {
            that.scale = window.config.preW;
            $(that.$refs.sliderBar).css("transform", "scale(" + 1 / that.scale + ")");
            $(that.$refs.sliderBar).css("width", 100 * that.scale + "%");
          });
        } else {
          let that = this;
          this.videoBaseUrl = bmeConfig.easyNvrUrl;
          this.easyNvrProtocol = bmeConfig.easyNvrProtocol;
          this.record_destroy();
          this.$nextTick(function () {
            that.getChannelStream(that.szIP, that.iChannelId);
          });
        }
      },
      deep: true,
    },
    videoInfo: {
      handler(newVal) {
        console.log("videoInfo", newVal);
        this.videoBaseUrl = bmeConfig.easyNvrUrl;
        this.easyNvrProtocol = bmeConfig.easyNvrProtocol;
        this.iChannelId = newVal.channelId;
        this.szIP = newVal.nvrIp;
        this.username = newVal.nvrUsername;
        this.password = newVal.nvrPassword;
        this.ipAddress = newVal.ipAddress;
        this.recordeId = newVal.recordeId;
        if (
          (this.ipAddress || (this.iChannelId && this.szIP)) &&
          this.username &&
          this.password
        ) {
          this.nvrChannel = this.szIP + "_" + this.iChannelId;
          this.getChannelStream(this.szIP, this.iChannelId, this.ipAddress);
          this.scale = 1; //bmeConfig.scaleRate;
          console.log("nvrIp", this.szIP);
          console.log("password", this.password);
          console.log("channelId", this.iChannelId);
        }
      },
      deep: true,
      immediate: true,
    },
    getVideoClose: {
      handler(newVal) {
        let state = unref(newVal);
        if (state) {
          this.close();
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.iChannelId && this.szIP && this.username && this.password) {
      this.nvrChannel = this.szIP + "_" + this.iChannelId;
      //this.ipAddress = this.ipAddress;

      console.log("nvrIp", this.szIP);
      console.log("password", this.password);
      console.log("channelId", this.iChannelId);
      //this.getChannelStream(this.iChannelId);
      this.getChannelStream(this.szIP, this.iChannelId, this.ipAddress);
      this.scale = 1;
    }
    if (bmeConfig.styleType === "typeGreen") {
      $(".nvr-box").css("background", "#0e524c");
      $(".player_setting").css("background", "#0e524c");
    } else if (bmeConfig.styleType === "typeDark") {
      $(".nvr-box").css("background", "#000000bf");
      $(".player_setting").css("background", "#000000");
    }
    //console.log("dialog.channelId", this.iChannelId);
  },
  beforeMount() {
    if (this.keepAliveTimer) {
      clearTimeout(this.keepAliveTimer);
    }
  },
  computed: {
    ...mapState({ dialog: (state) => state.dialog }),
    ...mapState({ app: (state) => state.app }),
    ...mapGetters(["dialogVisible"]),
  },
  methods: {
    ...mapActions(["setDialog"]),
    goReview() {
      this.isLive = false;
    },
    clickPlaySlow() {
      if (this.recoderVideo) {
        if (this.recoderVideo.playbackRate && this.recoderVideo.playbackRate > 1) {
          this.recoderVideo.playbackRate = 1;
        } else {
          this.recoderVideo.playbackRate = 0.5;
        }
      }
    },
    clickPlayFast() {
      if (this.recoderVideo) {
        if (this.recoderVideo.playbackRate && this.recoderVideo.playbackRate < 1) {
          this.recoderVideo.playbackRate = 1;
        } else {
          this.recoderVideo.playbackRate = 2;
        }
      }
    },
    goLive() {
      this.isLive = true;
      this.isVideo = true;
    },
    initVideo(flvUrl, deviceID, channelID, token) {
      let that = this;
      this.flvUrl = flvUrl;
      //this.curChannel = Channel;
      this.isVideo = true;
      if (Hls.isSupported() && flvUrl) {
        this.$nextTick(function () {
          that.flvPlayer = document.getElementById("myPlayer"); // 获取 video 标签
          that.hls = that.hls ? that.hls : new Hls(); // 实例化 Hls 对象
          that.hls.loadSource(that.videoBaseUrl + flvUrl); // 传入路径
          that.hls.attachMedia(that.flvPlayer);
          //that.hls.off(Hls.Events.MANIFEST_PARSED);
          that.hls.on(Hls.Events.MANIFEST_PARSED, function () {
            that.flvPlayer.play(); // 调用播放 API

            //that.keepFlvAlive(flvUrl, deviceID, channelID, token);
            if (that.keepAliveTimer) {
              clearTimeout(that.keepAliveTimer);
            }
            that.keepAliveTimer = setTimeout(function () {
              that.keepFlvAlive(flvUrl, deviceID, channelID, token);
            }, 30 * 1000);
          });
        });
      }
    },
    initVideo_(flvUrl, deviceID, channelID, token) {
      let that = this;
      this.flvUrl = flvUrl;
      //this.curChannel = Channel;
      this.isVideo = true;
      let myPlayer = document.getElementById("myPlayer");
      if (flvjs.isSupported()) {
        let videoBaseUrl = this.videoBaseUrl;
        if (this.easyNvrProtocol === "WS-FLV") {
          videoBaseUrl = videoBaseUrl.replace(/http:\/\//g, "ws://");
        }
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          isLive: true, //<====加个这个
          //url: "ws://localhost:10800/ws/flv/hls/stream_" + channel + ".flv", //<==自行修改
          url: videoBaseUrl + flvUrl,
          duration: 0,
        });
        this.flvPlayer.attachMediaElement(myPlayer);
        this.flvPlayer.load(); //加载
        this.flvPlayer.play();
        if (this.flvTimer) {
          clearInterval(this.flvTimer);
        }
        this.flvTimer = setInterval(() => {
          if (!that.flvPlayer.buffered.length) {
            return;
          }
          let end = that.flvPlayer.buffered.end(0);
          let diff = end - that.flvPlayer.currentTime;
          if (diff >= 1.5) {
            that.flvPlayer.currentTime = end - 0.1;
          }
        }, 3 * 10 * 1000);
        //this.keepFlvAlive(flvUrl, deviceID, channelID, token);
        if (this.keepAliveTimer) {
          clearTimeout(this.keepAliveTimer);
        }
        this.keepAliveTimer = setTimeout(function () {
          that.keepFlvAlive(flvUrl, deviceID, channelID, token);
        }, 30 * 1000);
      }
    },
    initRecode(url, args, deltaSec) {
      let that = this;
      this.recorderUrl = url;
      //this.curChannel = Channel;
      this.isVideo = false;
      let recoderVideo = document.getElementById("recoderVideo");
      if (flvjs.isSupported()) {
        let videoBaseUrl = this.videoBaseUrl;
        if (this.easyNvrProtocol === "WS-FLV") {
          videoBaseUrl = videoBaseUrl.replace(/http:\/\//g, "ws://");
        }
        this.recoderVideo = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true, //<====加个这个
            //url: "ws://localhost:10800/ws/flv/hls/stream_" + channel + ".flv", //<==自行修改
            url: videoBaseUrl + url,
            duration: 0,
          } /*,
          {
            enableStashBuffer: false,
            isLive: true,
            lazyLoad: false,
            lazyLoadMaxDuration: 0,
            lazyLoadRecoverDuration: 0,
            deferLoadAfterSourceOpen: false,
            fixAudioTimestampGap: false,
          }*/
        );
        this.recoderVideo.attachMediaElement(recoderVideo);
        this.recoderVideo.load(); //加载
        if (deltaSec && deltaSec > 0) {
          /*that.recoderVideo.addEventListener("loadstart", function () {
                that.recoderVideo.currentTime = parseInt(deltaSec / 1000);
              });*/
          this.recoderVideo.onloadedmetadata = function () {
            console.log(that.recoderVideo.duration);
            //that.recoderVideo.pause();
            this.recoderVideo.currentTime = parseInt(deltaSec / 1000);
          };
        }

        this.recoderVideo.play();

        if (this.recorderTimer) {
          clearInterval(this.recorderTimer);
        }
        this.recorderTimer = setInterval(() => {
          if (!that.recoderVideo.buffered.length) {
            return;
          }
          let end = that.recoderVideo.buffered.end(0);
          let diff = end - that.recoderVideo.currentTime;
          if (diff >= 1.5) {
            that.recoderVideo.currentTime = end - 0.1;
          }
        }, 3 * 10 * 1000);
        //this.keepRecoderAlive(url, args);
        if (this.keepRecoderAliveTimer) {
          clearTimeout(this.keepRecoderAliveTimer);
        }
        this.keepRecoderAliveTimer = setTimeout(function () {
          that.keepRecoderAlive(url, args);
        }, 30 * 1000);
      }
    },
    recordChange(curRecodeTime) {
      //alert(this.recodeDate);
      if (curRecodeTime) {
        this.curRecodeTime = curRecodeTime;
      }
      let that = this;
      that.record_destroy();
      let curTimeObj = new Date(this.recodeDate);
      let curYear = curTimeObj.getFullYear();
      let curMonth = curTimeObj.getMonth() + 1;
      let curDate = curTimeObj.getDate();
      let curTime = new Date(
        curYear + "/" + curMonth + "/" + curDate + " 00:00:00"
      ).getTime();
      curTime = curTime + parseInt((this.curRecodeTime / 100) * 24 * 3600 * 1000);
      var timeObj = new Date(curTime);

      let timeObj_ = new Date(curTime + 3600 * 1000);
      for (let i = 0; i < this.recoderList.length - 1; i++) {
        if (
          this.recoderList[i]["b"] <= curTime &&
          this.recoderList[i + 1]["b"] > curTime
        ) {
          var selTime = this.recoderList[i]["s"];
          //let curDate = selTime.substr(0, 8);
          let tmpObj = this.recoderList[i];

          let selTimeFormat =
            selTime.substr(0, 4) +
            "/" +
            selTime.substr(4, 2) +
            "/" +
            selTime.substr(6, 2) +
            " " +
            selTime.substr(8, 2) +
            ":" +
            selTime.substr(10, 2) +
            ":" +
            selTime.substr(12, 2);

          let deltaSecond = timeObj.getTime() - new Date(selTimeFormat).getTime();

          let eTstemp = new Date(
            new Date(selTimeFormat).getTime() + tmpObj["duration"] * 1000
          );
          let endTime =
            eTstemp.getFullYear() +
            "" +
            that.convertDoubleNum(eTstemp.getMonth() + 1) +
            "" +
            that.convertDoubleNum(eTstemp.getDate()) +
            "" +
            that.convertDoubleNum(eTstemp.getHours()) +
            "" +
            that.convertDoubleNum(eTstemp.getMinutes()) +
            "" +
            that.convertDoubleNum(eTstemp.getSeconds());
          //http://localhost:18000/api/v1/devices/record/playback?file=ch0001_04010000663000000&duration=2240&stime=20210904114432&etime=20210904122152&channel=1&protocol=flv
          let tmpArgs =
            "file=" +
            tmpObj["name"] +
            "&duration=" +
            tmpObj["duration"] +
            "&stime=" +
            selTime +
            "&etime=" +
            endTime +
            "&channel=" +
            that.recordeId +
            "&protocol=flv";
          let getUrl = that.videoBaseUrl + "/api/v1/devices/record/playback?" + tmpArgs;

          axios
            .get(getUrl, {
              params: { token: window.easyAxiosToken },
            })
            .then((res) => {
              if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                let recorderUrl = res.data.EasyDarwin.Body.URL;
                that.initRecode(recorderUrl, tmpArgs, deltaSecond);
              }
            });
          break;
        }
      }
    },
    convertDoubleNum(val) {
      if (val < 10) {
        return "0" + val;
      } else {
        return "" + val;
      }
    },
    keepFlvAlive(flvUrl, deviceID, channelID, token) {
      let that = this;
      let ts = new Date().getTime();
      let getUrl =
        "/api/v1/devices/channelstream?device=" +
        deviceID +
        "&channel=" +
        channelID +
        "&protocol=flv&stream=main&url=" +
        flvUrl;
      axios.get(getUrl, {
        params: { token: window.easyAxiosToken },
      });

      if (this.keepAliveTimer) {
        clearTimeout(this.keepAliveTimer);
      }

      this.keepAliveTimer = setTimeout(function () {
        that.keepFlvAlive(flvUrl, deviceID, channelID, token);
      }, 30 * 1000);
    },
    keepRecoderAlive(url, args) {
      let that = this;
      let ts = new Date().getTime();
      let getUrl = "/api/v1/devices/record/playback?" + args + "&url=" + url;
      axios.get(getUrl, {
        params: { token: window.easyAxiosToken },
      });

      if (this.keepRecoderAliveTimer) {
        clearTimeout(this.keepRecoderAliveTimer);
      }

      this.keepRecoderAliveTimer = setTimeout(function () {
        that.keepRecoderAlive(url, args);
      }, 30 * 1000);
    },
    flv_destroy() {
      if (this.flvTimer) {
        clearInterval(this.flvTimer);
      }
      if (this.keepAliveTimer) {
        clearTimeout(this.keepAliveTimer);
      }
      try {
        this.flvPlayer.pause();
        this.flvPlayer.unload();
        this.flvPlayer.detachMediaElement();
        this.flvPlayer.destroy();
        this.flvPlayer = null;
        //http://localhost:18000/api/v1/devices/stopchannelstream?stream_type=play&device=1&channel=1&url=%2Fflv%2Fhls%2Fstream_1_0.flv
        let getUrl =
          "/api/v1/devices/stopchannelstream?stream_type=play&device=" +
          this.deviceId +
          "&channel=" +
          this.iChannelId +
          "&url=" +
          this.flvUrl +
          "&token=" +
          window.easyAxiosToken;
        $.ajax({
          url: getUrl,
          success: function (res) {
            console.log(res);
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    record_destroy() {
      if (this.recorderTimer) {
        clearInterval(this.recorderTimer);
      }
      if (this.keepRecoderAliveTimer) {
        clearTimeout(this.keepRecoderAliveTimer);
      }
      try {
        this.recoderVideo.pause();
        this.recoderVideo.unload ? this.recoderVideo.unload() : "";
        this.recoderVideo.detachMedia ? this.recoderVideo.detachMedia() : "";
        this.hls.unload ? this.hls.unload() : "";
        this.hls.detachMedia ? this.hls.detachMedia() : "";
        this.hls.destroy();
        this.hls = null;

        //http://localhost:18000/api/v1/devices/stopchannelstream?stream_type=playback&device=1&channel=1&url=%2Fflv%2Fhls%2Fstream_localhost_33_ch0001_04010000823000000_202195125727_202195131540.flv

        let getUrl =
          "/api/v1/devices/stopchannelstream?stream_type=playback&device=" +
          this.deviceId +
          "&channel=" +
          this.iChannelId +
          "&url=" +
          this.recorderUrl +
          "&token=" +
          window.easyAxiosToken;
        $.ajax({
          url: getUrl,
          success: function (res) {
            console.log(res);
          },
        });
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * 根据通道获取直播流地址
     */
    getChannelStream(szIP, iChannelId, ipAddress) {
      let that = this;
      let ts = new Date().getTime();
      let getUrl = bmeConfig.cvrNewApi
        ? "/api/v1/devicesconfig?start=0&limit=9999"
        : "/api/v1/devices?start=0&limit=9999";
      axios
        .get(getUrl, {
          params: { token: window.easyAxiosToken },
        })
        .then((res) => {
          if (res.data.EasyDarwin.Header.ErrorNum == 200) {
            let devices = res.data.EasyDarwin.Body.Devices;
            for (let i = 0; i < devices.length; i++) {
              if (devices[i]["DeviceIp"] === szIP) {
                let tmpDeviceID = devices[i]["DeviceID"];
                that.deviceId = tmpDeviceID;
                let tmpChannels = devices[i]["channels"];
                for (let j = 0; j < tmpChannels.length; j++) {
                  if (tmpChannels[j]["Name"] === iChannelId) {
                    let tmpChannelID = tmpChannels[j]["ChannelID"];
                    let tmpToken = tmpChannels[j]["Token"];

                    let getUrl =
                      "/api/v1/devices/channelstream?device=" +
                      tmpDeviceID +
                      "&channel=" +
                      tmpChannelID +
                      "&protocol=flv&stream=main";
                    axios
                      .get(getUrl, {
                        params: { token: window.easyAxiosToken },
                      })
                      .then((res) => {
                        console.log("======================");
                        console.log(res);
                        if (res.data.EasyDarwin.Header.ErrorNum == 200) {
                          let flvUrl = res.data.EasyDarwin.Body.URL;
                          if (that.easyNvrProtocol === "HLS") {
                            that.initVideo(flvUrl, tmpDeviceID, tmpChannelID, tmpToken);
                          } else {
                            that.initVideo_(flvUrl, tmpDeviceID, tmpChannelID, tmpToken);
                          }
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    break;
                  }
                }
                break;
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    date_change() {
      let that = this;
      this.recodeDate;
      let ts = new Date().getTime();
      let curDailyObj = new Date(this.recodeDate);
      let curDaily =
        curDailyObj.getFullYear() +
        this.convertDoubleNum(curDailyObj.getMonth() + 1) +
        this.convertDoubleNum(curDailyObj.getDate());
      ///api/v1/record/querydaily?id=1&recordType=Cloud&period=20210904
      let getUrl =
        "/api/v1/record/querydaily?id=" +
        this.recordeId +
        "&recordType=Device" +
        "&period=" +
        curDaily +
        "&_=" +
        ts +
        "&token=" +
        window.easyAxiosToken;
      $.ajax({
        url: getUrl,
        success: function (res) {
          console.log(res);
          that.recoderList = [];
          let tmpList = res.list;
          tmpList.forEach((item) => {
            let stStr =
              item.startAt.substr(0, 4) +
              "/" +
              item.startAt.substr(4, 2) +
              "/" +
              item.startAt.substr(6, 2) +
              " " +
              item.startAt.substr(8, 2) +
              ":" +
              item.startAt.substr(10, 2) +
              ":" +
              item.startAt.substr(12, 2);
            let strB =
              item.startAt.substr(0, 4) +
              "/" +
              item.startAt.substr(4, 2) +
              "/" +
              item.startAt.substr(6, 2) +
              " 00:00:00";
            let strE =
              item.startAt.substr(0, 4) +
              "/" +
              item.startAt.substr(4, 2) +
              "/" +
              item.startAt.substr(6, 2) +
              " 23:59:59";
            let st = new Date(stStr).getTime();
            let delta = st - new Date(strB).getTime();
            let delta_ = new Date(strE).getTime() - new Date(strB).getTime();
            let l = Math.floor((delta / delta_) * 1440);
            let w = Math.floor(((item.duration * 1000) / delta_) * 1440) - 2;
            that.recoderList.push({
              l: l,
              w: w,
              hls: item.hls,
              b: st,
              s: item.startAt,
              duration: item.duration,
              name: item.name,
              startAt: item.startAt,
            });
          });
          that.flv_destroy();
          that.recordChange(1);
        },
      });
    },
    formatTooltip(val) {
      let curTS = (val / 100) * 24 * 3600 * 1000;
      let hourStr = Math.floor(curTS / (3600 * 1000));
      let minuteStr = Math.floor((curTS % (3600 * 1000)) / (60 * 1000));
      let secondStr = Math.floor((curTS % (60 * 1000)) / 1000);
      return (
        (hourStr < 10 ? "0" + hourStr : hourStr) +
        ":" +
        (minuteStr < 10 ? "0" + minuteStr : minuteStr) +
        ":" +
        (secondStr < 10 ? "0" + secondStr : secondStr)
      );
    },
    async close() {
      this.flv_destroy();
      this.record_destroy();
      this.isLive = true;
      this.updateVideoType();
      //this.setDialog({ visible: false });
    },
  },
  beforeUnmount() {
    if (this.keepAliveTimer) {
      clearTimeout(this.keepAliveTimer);
    }
    if (this.keepRecoderAliveTimer) {
      clearTimeout(this.keepRecoderAliveTimer);
    }
    this.flv_destroy();
    this.record_destroy();
    //	this.clickStopRealPlay();

    //playbackRate   currentTime  currentTime
  },
  components: {},
};
</script>
<style lang="scss">
.recoder-bar {
  .block {
    z-index: 99;
    position: absolute;
    left: 0px;
    transform-origin: left top;
  }
  .el-slider__runway {
    background: none !important;
    margin: 0px !important;
  }
  .el-slider__bar {
    background: darkorange !important;
  }
}
</style>
<style lang="scss" scoped="scoped">
.nvr-box-large {
  //   @include bg-box(1470px, 960px, "bg.png");
}
.nvr-box-tiny {
  //   @include bg-box(1200px, 785px, "bg.png");
}
.nvr-box {
  //   @include bg-box(1470px, 840px, "bg.png");
  /*@include bg-box(1200px, 840px, "bg.png");*/
  /*margin-left: -735px;*/
  position: relative;
  padding: 10px 10px 20px;
  .close-box {
    top: 6px;
    right: 6px;
    // background-image: url("./img/close.png");
    &:hover {
      //   background-image: url("./img/close_active.png");
    }
  }
  .nvr-back-box {
    position: absolute;
    top: 6px;
    right: 135px;
    // @include bg-box(122px, 38px, "back.png");
    z-index: 1;
    cursor: pointer;
    &:hover {
      //   background-image: url("./img/back_active.png");
    }
  }
  /*.close-box{
		position: absolute;
		top: 0;
		right: -100px;
		@include bg-box(80px,80px,"icon_close.png");
		width: 80px;
		height: 80px;
		background-image: url("./../img/close.png");
		background-size: 100% 100%;
		cursor: pointer;
	}*/
  .nvr-player {
    width: 100%;
    height: 100%;
    /*height: calc(100% - 90px);*/
    // padding-top: 70px;
    /*background: url("./img/example.png");*/
    background-size: 100% 100%;
    position: relative;
    .player_title {
      width: 100%;
      background: #000;
      position: absolute;
      top: 0px;
      left: 0;
      font-size: 26px;
      line-height: 50px;
      padding-left: 10px;
    }
    #divPlugin {
      /*width: 100%;
			height: 100%;*/
      /*width: 1470px;*/
      height: 600px;
      position: relative;
      z-index: 1;
    }
    .player_setting {
      position: absolute;
      /*bottom: -130px;*/
      bottom: 0;
      left: 0;
      width: 100%;
      height: 90px;
      /*background:rgba(0,2,2,.6);*/
      background: rgba(0, 0, 0, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 100000;
      &:before {
        content: "";
        position: absolute;
        bottom: 0;
        /*@include bg-box(100%,30px,"bg_bottom.png")*/
      }
      .player_left {
        display: flex;
        align-items: center;
        .player_left_inner {
          display: flex;
        }
        .icon_play {
          width: 40px;
          height: 40px;
          margin: 0 25px 0 35px;
          background-image: url("./img/icon_pause.png");
          background-size: 100% 100%;
          cursor: pointer;
        }
        .icon_pause {
          background-image: url("./img/icon_play.png");
        }

        .player_time {
          font-size: 25px;
        }
      }
    }
    .player_right {
      display: flex;
      height: 80px;
      .speed_box {
        ul {
          display: flex;
          position: relative;
          margin-left: 15px;
          li {
            margin-top: 20px;
            width: 76px;
            height: 40px;
            border: 1px solid rgba(62, 147, 255, 0.8);
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.23) 0%,
              rgba(19, 82, 162, 0.6) 100%
            );
            opacity: 1;
            border-radius: 4px;
            margin-right: 17px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-size: 20px;
            cursor: pointer;
          }
        }
      }
      .player_SE {
        display: flex;
        .chooseTime {
          display: flex;
          align-items: center;
          margin-right: 20px;
          label {
            font-size: 20px;
          }
          .chooseTimeBg {
            width: 300px;
            height: 40px;
            background: rgba(89, 91, 95, 0.56);
            opacity: 1;
            border-radius: 6px;
            input {
              width: 100%;
              height: 100%;
              font-size: 24px;
              padding-left: 10px;
            }
          }
        }
        .back_confirm {
          font-size: 26px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          cursor: pointer;
        }
      }
      .player_live_back {
        margin-right: 60px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .icon_live_back {
          display: inline-block;
          width: 30px;
          height: 30px;
          margin-right: 10px;
          margin-top: 8px;
          background-image: url("./img/icon_replay_default.png");
          background-size: 100% 100%;
        }
        span {
          font-size: 28px;
        }
      }
      .player_speed {
        display: flex;
        align-items: center;
        margin-right: 50px;
        label {
          font-size: 26px;
        }
      }
    }

    .drag-point {
      position: absolute;
      left: 0px;
      top: -5px;
      width: 20px;
      height: 20px;
      border-radius: 10px;
    }
    .recoder-bar {
      position: relative;
      height: 10px;
      background: #666;
    }
    .recoders {
      position: absolute;
      height: 5px;
      background: #fff;
      border: 1px solid #ccc;
    }
    .hour-item {
      display: inline-block;
      position: relative;
      width: 60px;
      text-align: center;
      background: #fff;
      color: darkorange;
      border-right: 1px solid #000;
    }
  }
}
</style>
<style type="text/css" lang="scss">
.nvr-player {
  .chooseTimeBg {
    .el-date-editor {
      width: 100%;
      height: 100%;
      margin: 0;
      display: flex;
      align-items: center;
      .el-input__inner {
        background: transparent;
        border: 0;
        font-size: 24px;
        color: #fff;
      }
      .el-input__icon,
      .el-input__prefix {
        display: none;
      }
    }
  }
}
/*.el-date-picker{
	top: 880px!important;
}*/
</style>
<style type="text/css">
/*用于定位海康视频时间框位置*/
.video_date_class_cvr {
  /*top: 19%!important;
		left: 72%!important;*/
  top: 26% !important;
  left: 73% !important;
  zoom: 0.9 !important;
  /*top: 257px!important;
		left: 1830px!important;*/
  /*top: 620px!important;
		left: 2730px!important;*/
}
/*不能选择项*/
.video_date_class_cvr .el-date-table td.disabled div {
  background-color: #000;
}
.video_date_class_cvr .el-date-table td span {
  border-radius: initial;
}
.video_date_class_cvr .el-picker-panel__footer .el-button {
  background: #409eff;
  color: #fff;
}
</style>
